import { computed } from '@vue/composition-api';

import type { Topic } from '@/modules/advisor-search/api/useUsersApi';

import { separateNumber } from '@/helpers/filters';

export const useAdvisorSearchUserTopic = (props: { topic: Topic }) => {
  const price = computed(() =>
    props.topic.price
      ? `¥${separateNumber(props.topic.price)} ~`
      : '問い合わせ',
  );

  return {
    price,
  };
};
